import React from 'react';
import { useLocaleKey } from '../hooks/useLocaleKey';

/**
 * Remounts children when locale changes so data loaded in useEffect([]) refetches with Accept-Language.
 */
export default function LocaleRefreshBoundary({ children }) {
  const localeKey = useLocaleKey();
  return <React.Fragment key={localeKey}>{children}</React.Fragment>;
}
